module.exports = __webpack_public_path__ + "img/Traning.f497e84a.svg";